import { baseApi } from '@store/baseApi';
import type { PayerStatsResponse } from '@store/generated/patient-coverage';

const payerStatsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getPayerStats: builder.query<PayerStatsResponse, void>({
      query: () => ({ url: '/v2/provider/patients/payer-stats' }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPayerStatsQuery: usePayerStatsQuery } = payerStatsApi;
